import { UserModel } from "../../user/_models/user.model";

export class PermissionModel {
  id: number;
  name: string;
  codename: string;
  content_type: any;
}
